/**
 * FBSBancaRIOBAMBA
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EfectivizarTransferenciaInternasME {
  usuarioId?: string | null;
  numeroCuentaOrigen?: string | null;
  numeroCuentaDestino?: string | null;
  identificacion?: string | null;
  nombreOrdenante?: string | null;
  correoBeneficiario?: string | null;
  telefonoBeneficiario?: string | null;
  detalle?: string | null;
  codigoUsuarioBanca?: string | null;
  otp?: string | null;
  valor?: number;
  montoDiario?: number;
  montoMensual?: number;
  esDesdeMovil?: boolean;
  esPropia?: boolean;
  esPagoBilleteraMovil?: boolean;
  omiteOTP?: boolean;
  agregaContacto?: boolean;
}
